import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTires = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
			fill: "#DBE4E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 19.2727C16.0166 19.2727 19.2727 16.0166 19.2727 12C19.2727 7.98341 16.0166 4.72729 12 4.72729C7.98341 4.72729 4.72729 7.98341 4.72729 12C4.72729 16.0166 7.98341 19.2727 12 19.2727Z",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
			stroke: "#293235",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.9999,
			cy: 12.0001,
			r: 1.31818,
			stroke: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2191 18.8181H12.9607C13.2696 18.8181 13.5047 18.5407 13.4539 18.2359L13.1335 16.3138C13.0933 16.0727 12.8847 15.896 12.6403 15.896H11.5394C11.295 15.896 11.0864 16.0727 11.0462 16.3138L10.7259 18.2359C10.6751 18.5407 10.9101 18.8181 11.2191 18.8181Z",
			stroke: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9605 5.18188H11.2189C10.9099 5.18188 10.6749 5.45932 10.7257 5.76408L11.046 7.68616C11.0862 7.92726 11.2948 8.10396 11.5392 8.10396H12.6402C12.8846 8.10396 13.0932 7.92726 13.1334 7.68616L13.4537 5.76408C13.5045 5.45932 13.2695 5.18188 12.9605 5.18188Z",
			stroke: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.74973 14.6549L6.62053 16.1632C6.77502 16.4307 7.13279 16.4956 7.37133 16.2992L8.87573 15.0607C9.06443 14.9054 9.11316 14.6364 8.99095 14.4247L8.44049 13.4713C8.31828 13.2596 8.06095 13.1673 7.83207 13.253L6.00733 13.9367C5.71799 14.0451 5.59524 14.3873 5.74973 14.6549Z",
			stroke: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4301 9.34512L17.5593 7.83684C17.4048 7.56926 17.047 7.50444 16.8085 7.70082L15.3041 8.93928C15.1154 9.09463 15.0666 9.36363 15.1889 9.57531L15.7393 10.5287C15.8615 10.7404 16.1189 10.8327 16.3477 10.747L18.1725 10.0633C18.4618 9.95495 18.5846 9.6127 18.4301 9.34512Z",
			stroke: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5592 16.1632L18.43 14.655C18.5845 14.3874 18.4617 14.0451 18.1724 13.9367L16.3476 13.2531C16.1188 13.1674 15.8614 13.2597 15.7392 13.4713L15.1888 14.4248C15.0665 14.6364 15.1153 14.9054 15.304 15.0608L16.8084 16.2993C17.0469 16.4956 17.4047 16.4308 17.5592 16.1632Z",
			stroke: "#293235"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.62051 7.83676L5.7497 9.34505C5.59522 9.61262 5.71797 9.95487 6.00731 10.0633L7.83205 10.7469C8.06093 10.8326 8.31826 10.7403 8.44047 10.5287L8.99093 9.57523C9.11314 9.36356 9.06441 9.09455 8.87571 8.93921L7.37131 7.70074C7.13277 7.50437 6.775 7.56919 6.62051 7.83676Z",
			stroke: "#293235"
		})
	]
});
const ForwardRef = forwardRef(SvgTires);
export { ForwardRef as ReactComponent };
